import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/learn/saint-tms-cost-insurance-coverage",
)({
  beforeLoad: () => {
    throw redirect({ to: "/learn/saint-tms-cost", replace: true });
  },
});
